// extracted by mini-css-extract-plugin
export default {"container":"ToggleButton_container__FwwI7","left":"ToggleButton_left__VLzMQ","top":"ToggleButton_top__AbRPb"};